import { render, staticRenderFns } from "./hqglTelSetupReg.vue?vue&type=template&id=10de7a06&scoped=true&"
import script from "./hqglTelSetupReg.vue?vue&type=script&lang=js&"
export * from "./hqglTelSetupReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10de7a06",
  null
  
)

export default component.exports